import React, { useEffect, useState } from "react";
import {
  Carousel,
  Col,
  Divider,
  Row,
  Slider,
  Button,
  Popover,
  Typography,
  InputNumber,
  Checkbox,
  Select,
} from "antd";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaAngleDown, FaBed, FaMapMarkerAlt, FaBath } from "react-icons/fa";
import { citiesByState, states } from "../dummyData/states&cities";
import { Collapse } from "antd";
import { useMediaQuery } from "../utils/mediaQueries";

// api
const { getAllProperty } = require("../api/propertyApi");

const { Text } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

const FilterContainer = styled.div`
  width: 100vw;
  margin: auto;
  padding: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 10px;
`;

const CustomStyledButton = styled(Button)`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const PropertyListingsContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 15vw));
  grid-gap: 24px;
  margin: 20px auto;
  justify-content: center;
  align-content: center;
`;

const PropertyContainer = styled.div`
  background: #ffffff;
  max-width: 100%;
  position: relative;
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  transform-origin: center bottom;

  &:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

const PropertyDetails = styled.div`
  margin-bottom: 3px;
  margin-top: 3px;
`;

const StatusBox = styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  background-color: #ffffff74;
  color: #000000;
  padding: 4px 12px;
  font-size: 12px;
  border-radius: 5px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

const PropertyInfoContainer = styled.div`
  padding: 24px;
  gap: 5px;
`;

const PropertyListings = () => {
  const [propertyList, setPropertyList] = useState("");
  const [filters, setFilters] = useState({
    city: [],
    state: [],
    minPrice: null,
    maxPrice: null,
    status: ["terjual"],
    minBathrooms: null,
    maxBathrooms: null,
    minBedrooms: null,
    maxBedrooms: null,
    minPropertySize: null,
    maxPropertySize: null,
    propertyType: [],
  });

  // State variables for section visibility
  const [locationVisible] = useState(true);
  const [priceVisible] = useState(true);
  const [bathroomsVisible] = useState(true);
  const [bedroomsVisible] = useState(true);
  const [propertySizeVisible] = useState(true);
  const [propertyTypeVisible] = useState(true);

  const fetchProperty = async () => {
    const propertyData = await getAllProperty(filters);
    setPropertyList(propertyData);
  };
  const isMobile = useMediaQuery("(max-width: 1100px)");

  const handleFilterChange = (field, value) => {
    if (Array.isArray(field)) {
      setFilters({
        ...filters,
        [field[0]]: value[0],
        [field[1]]: value[1],
      });
    } else {
      setFilters({
        ...filters,
        [field]: value,
      });
    }
  };

  const handleResetFilters = async () => {
    setFilters({
      city: [],
      state: [],
      minPrice: null,
      maxPrice: null,
      status: ["terjual"],
      minBathrooms: null,
      maxBathrooms: null,
      minBedrooms: null,
      maxBedrooms: null,
      minPropertySize: null,
      maxPropertySize: null,
      propertyType: [],
    });
  };

  useEffect(() => {
    fetchProperty();
  }, []);

  useEffect(() => {
    console.log(filters);
    fetchProperty();
  }, [filters]);

  const handleLocationStateChange = (value) => {
    handleFilterChange("state", value);
  };

  const handleLocationCityChange = (value) => {
    handleFilterChange("city", value);
  };

  const propertyTypes = [
    "Agriculture Land",
    "Apartment",
    "Bungalow",
    "Bungalow Lot Land",
    "Corner Lot",
    "Double Storey Bungalow",
    "Double Storey Semi D",
    "Double Storey Shoplot",
    "Double Storey Terrace",
    "Residential Land",
    "Semi D Cluster",
    "Semi Detached",
    "Single Storey 1½ Terrace",
    "Single Storey Bungalow",
    "Single Storey Semi D",
    "Single Storey Shoplot",
    "Single Storey Terrace",
    "Single Storey Terrace Endlot",
    "Three Storey Bungalow",
    "Three Storey Shoplot",
  ];

  return (
    <>
      <FilterContainer>
        <Popover
          content={
            <div style={isMobile ? { width: "90vw" } : { width: "60vw" }}>
              <Collapse>
                <Panel
                  header="Location"
                  key="1"
                  showArrow={locationVisible} // Set the showArrow prop to the visibility state
                >
                  <div
                    style={{
                      display: locationVisible ? "block" : "none",
                      flexDirection: "column",
                    }}
                  >
                    <Select
                      placeholder="Select State"
                      onChange={handleLocationStateChange}
                      value={filters.state}
                      style={{ width: "100%" }}
                    >
                      {states.map((state) => (
                        <Option key={state} value={state}>
                          {state}
                        </Option>
                      ))}
                    </Select>
                    <Select
                      mode="multiple"
                      placeholder="Select City"
                      onChange={handleLocationCityChange}
                      value={filters.city}
                      style={{ width: "100%" }}
                      allowClear
                    >
                      {filters.state &&
                        citiesByState[filters.state]?.map((city) => (
                          <Option key={city} value={city}>
                            {city}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </Panel>
                <Panel
                  header="Price Range"
                  key="2"
                  showArrow={priceVisible} // Set the showArrow prop to the visibility state
                >
                  <div
                    style={{
                      display: priceVisible ? "block" : "none",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <InputNumber
                        min={0}
                        max={100000000000}
                        value={filters.minPrice}
                        onChange={(value) =>
                          handleFilterChange("minPrice", value)
                        }
                      />
                      <InputNumber
                        min={0}
                        max={100000000000}
                        value={filters.maxPrice}
                        onChange={(value) =>
                          handleFilterChange("maxPrice", value)
                        }
                      />
                    </div>
                  </div>
                </Panel>
                <Panel
                  header="Bathrooms"
                  key="4"
                  showArrow={bathroomsVisible} // Set the showArrow prop to the visibility state
                >
                  <div
                    style={{
                      display: bathroomsVisible ? "block" : "none",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <InputNumber
                        min={0}
                        max={10}
                        value={filters.minBathrooms}
                        onChange={(value) =>
                          handleFilterChange("minBathrooms", value)
                        }
                      />
                      <InputNumber
                        min={0}
                        max={10}
                        value={filters.maxBathrooms}
                        onChange={(value) =>
                          handleFilterChange("maxBathrooms", value)
                        }
                      />
                    </div>
                  </div>
                </Panel>
                <Panel
                  header="Bedrooms"
                  key="5"
                  showArrow={bedroomsVisible} // Set the showArrow prop to the visibility state
                >
                  <div
                    style={{
                      display: bedroomsVisible ? "block" : "none",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <InputNumber
                        min={0}
                        max={10}
                        value={filters.minBedrooms}
                        onChange={(value) =>
                          handleFilterChange("minBedrooms", value)
                        }
                      />
                      <InputNumber
                        min={0}
                        max={10}
                        value={filters.maxBedrooms}
                        onChange={(value) =>
                          handleFilterChange("maxBedrooms", value)
                        }
                      />
                    </div>
                  </div>
                </Panel>
                <Panel
                  header="Property Size"
                  key="6"
                  showArrow={propertySizeVisible} // Set the showArrow prop to the visibility state
                >
                  <div
                    style={{
                      display: propertySizeVisible ? "block" : "none",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <InputNumber
                        min={0}
                        max={10000000000}
                        value={filters.minPropertySize}
                        onChange={(value) =>
                          handleFilterChange("minPropertySize", value)
                        }
                      />
                      <InputNumber
                        min={0}
                        max={10000000000}
                        value={filters.maxPropertySize}
                        onChange={(value) =>
                          handleFilterChange("maxPropertySize", value)
                        }
                      />
                    </div>
                  </div>
                </Panel>
                <Panel
                  header="Property Type"
                  key="7"
                  showArrow={propertyTypeVisible} // Set the showArrow prop to the visibility state
                >
                  <div
                    style={{
                      display: propertyTypeVisible ? "block" : "none",
                      flexDirection: "column",
                    }}
                  >
                    <Checkbox.Group
                      onChange={(values) =>
                        handleFilterChange("propertyType", values)
                      }
                      value={filters.propertyType}
                    >
                      {propertyTypes.map((type) => (
                        <div key={type}>
                          <Checkbox value={type}>{type}</Checkbox>
                        </div>
                      ))}
                    </Checkbox.Group>
                  </div>
                </Panel>
              </Collapse>
              <Divider />
              <Button block onClick={handleResetFilters}>
                Reset Filters
              </Button>
            </div>
          }
          placement="bottom"
          trigger="click"
        >
          <CustomStyledButton type="ghost">
            <span>Filter</span>
            <FaAngleDown style={{ marginLeft: "5px" }} />
          </CustomStyledButton>
        </Popover>
      </FilterContainer>
      <PropertyListingsContainer>
        {propertyList &&
          propertyList.map((property) => (
            <PropertyContainer key={property._id}>
              <Link to={`/property/${property._id}`}>
                <Carousel
                  autoplay
                  dotStyle={{ borderRadius: "50%" }}
                  dotActiveStyle={{ borderRadius: "50%" }}
                  easing
                  effect="fade"
                >
                  {property.images.map((image, index) => (
                    <div key={index}>
                      <img
                        src={image.url}
                        alt={`Property ${property._id} - ${index + 1}`}
                        style={{
                          height: "200px",
                          width: "300px",
                          borderTopRightRadius: "5px",
                          borderTopLeftRadius: "5px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  ))}
                </Carousel>
              </Link>
              <StatusBox>
                <strong>{property.status}</strong>
              </StatusBox>
              <PropertyInfoContainer>
                <Row style={{ gap: "5px" }}>
                  <Col span={24}>
                    <PropertyDetails style={{ fontWeight: "bold" }}>
                      RM {property.price}
                    </PropertyDetails>
                  </Col>
                  <Col span={24}>
                    <PropertyDetails
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyItems: "space-evenly",
                      }}
                    >
                      {property.location}
                    </PropertyDetails>
                  </Col>
                </Row>
                <Row wrap>
                  <Col>
                    <PropertyDetails
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {property.propertySize + " m2"}
                      <Divider
                        type="vertical"
                        style={{ color: "black", borderColor: "#868686" }}
                      />
                      {property.amenities.bedroom}
                      <FaBed style={{ marginLeft: "2px" }} />
                      <Divider
                        type="vertical"
                        style={{ color: "black", borderColor: "#868686" }}
                      />
                      {property.amenities.bathroom}
                      <FaBath style={{ marginLeft: "2px" }} />
                      <Divider
                        type="vertical"
                        style={{ color: "black", borderColor: "#868686" }}
                      />
                    </PropertyDetails>
                  </Col>
                  {property.amenities.others.map((amenity, index) => (
                    <Col key={index}>
                      <PropertyDetails
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {amenity}
                        <Divider
                          type="vertical"
                          style={{
                            color: "black",
                            borderColor: "#868686",
                          }}
                        />
                      </PropertyDetails>
                    </Col>
                  ))}
                </Row>
              </PropertyInfoContainer>
            </PropertyContainer>
          ))}
      </PropertyListingsContainer>
    </>
  );
};

export default PropertyListings;
